import axios from "../axios";

export function getTenantDetails(email) {
    return axios.get(`tenant/${encodeURIComponent(email)}`).then(({ data }) => data);
}
